import React, { Fragment, useEffect, useState } from 'react';
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import moment from 'moment';
import EditRole from './EditRole';
import { getObjectsByPortal, updateHiddenObject, updateRolePermission, updateRole, getRoles } from '../../../api/User';
import { decryptData } from '../../../utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import { failed, success } from '../../../utils/Tostify';
import { permissionNames } from '../Constant';
import Loader from '../../../components/Loader/Loader';
import { useConfirmDialog } from '../../../hooks/useConfirmDialog';
import AddRoleAccessModal from '../user/AddRoleAccessModal';

function RolesDetails({ direction, setCurrentTab, roleData, userData, ...args }) {
    let token = useSelector(state => state.userReducer.token);
    const { getConfirmation } = useConfirmDialog();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('1');
    const [isActive, setIsActive] = useState(roleData?.active);
    const [objectDetails, setObjectDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setError] = useState("");
    const [userAssociatedRole, setUserAssociatedRole] = useState([]);
    const [showModalAddRole, setShowModalAddRole] = useState(false);
    const [showObjectListing, setShowObjectListing] = useState(false);
    const [object, setObject] = useState({ objectName: "", permission: [], isHidden: false });
    const [PortalObject, setPortalObject] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const toggleTab = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    const [dropdownOpen, setDropdownOpen] = useState([]);
    const toggleDropdown = (id) => {
        setDropdownOpen(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);
    };

    const getPlatformObjecs = async () => {
        const values = { portalLayout: roleData?.portalLayout };
        let res;
        try {
            res = await getObjectsByPortal({ values, dispatch, token });
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setPortalObject(responseData);
            }
        } catch (error) {
            failed(res?.message);
        }
    };

    const handleEdit = (obj) => {
        setShowObjectListing(true);
        setObjectDetails(obj);
    };

    const handleCheckBox = (e, objectName) => {
        const value = e.target.value;
        setObject(prevState => ({
            ...prevState,
            objectName: objectName,
            permission: e.target.checked
                ? [...prevState.permission, value]
                : prevState.permission.filter(permission => permission !== value)
        }));
        setError("");
    };

    const handleHiddenToggle = async (e, objectName) => {
        const isChecked = e.target.checked;
        e.target.checked = !isChecked;
        const msg = isChecked ? "hide" : "unhide";
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: `Are you sure you want to ${msg} ${objectName}?`
        });
        if (confirmed) {
            const values = { roleId: roleData?._id, objectName: objectName, isHidden: isChecked };
            let res;
            try {
                setIsLoading(true);
                res = await updateHiddenObject({ values, dispatch, token });
                if (res?.status === "SUCCESS") {
                    await getRolesUser();
                    setIsLoading(false);
                    success(res?.message);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        } else {
            e.target.checked = !isChecked;
        }
    };

    const handleSubmit = async () => {
        if (object?.permission?.length == 0) {
            setError("At least one permission required");
            return true;
        }
        const values = { roleId: roleData?._id, permissions: object };
        let res;
        try {
            setIsLoading(true);
            res = await updateRolePermission({ values, dispatch, token });
            if (res?.status == "SUCCESS") {
                await getRolesUser();
                setShowObjectListing(false);
                setIsLoading(false);
                success(res?.message);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
    };

    const handleActiveInActiveToggle = async(e)=>{
        const currentChecked = e.target.checked;
        e.target.checked = !currentChecked;
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message : `Are you want to ${currentChecked === true ? "Activate" : "Deactivate"} Role ${userAssociatedRole?.items?.[0]?.roleName}`
        });
        if(confirmed){
            let values = {active : currentChecked, roleId: roleData?._id};
            let res;
            try {
                setIsLoading(true);
                res = await updateRole({values, dispatch, token });
                if (res?.status == "SUCCESS") {
                    setIsLoading(false);
                    success(res?.message);
                    setIsActive(currentChecked);
                }else{
                  setIsLoading(false);
                  failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }else{
            e.target.checked = !currentChecked;
        }
    };

      const getRolesUser = async(page, limit, searchKey = "")=>{
        let res;
        try {
            setIsLoading(true);
            // setSearch(searchKey);
            res = await getRoles({ dispatch, token, page, limit, searchKey, roleId: roleData?._id });
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                // dispatch(userActions.rolesListing(responseData));
                setUserAssociatedRole(responseData);
                setIsLoading(false);
            }else{
              setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
      };


    useEffect(() => {
        getPlatformObjecs();
        getRolesUser();
    }, []);

    useEffect(() => {
        const initialPermissions = roleData?.permissions?.find((val) => val?.objectName === objectDetails?.objectName)?.permission || [];
        const initialIsHidden = roleData?.permissions?.find((val) => val?.objectName === objectDetails?.objectName)?.isHidden || false;
        setObject((prevObject) => ({
          ...prevObject,
          permission: initialPermissions,
          isHidden: initialIsHidden
        }));
      }, [roleData, objectDetails]);

    return (
        <Fragment>
            {isLoading && <Loader />}
            {showModal && <EditRole  refetch={()=> getRolesUser()} setCurrentTab={setCurrentTab} roleData={userAssociatedRole?.items?.[0]} setShowModal={() => setShowModal(!showModal)} />}
            {showModalAddRole && <AddRoleAccessModal refetch={()=> getRolesUser()} setShowModalAddRole={() => setShowModalAddRole(!showModalAddRole)} from={"userToRole"} assignedUser={roleData?.usersWithRole} roleData={roleData} />}
            <div className='rolesdetails_container'>
                <div>
                    <Nav tabs>
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === '1' })} onClick={() => toggleTab('1')}>Role Details</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === '2' })} onClick={() => toggleTab('2')}>Users</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={classnames({ active: activeTab === '3' })} onClick={() => toggleTab('3')}>Objects</NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                    <div className='profile_block'>
                                    <div className='profile_main d-flex justify-content-between align-items-center flex-wrap gap-3'>
                                            <div className='profile_info flex-wrap'>
                                                <div>
                                                    <h6>{userAssociatedRole?.items?.[0]?.roleName}</h6>
                                                    <p>{userAssociatedRole?.items?.[0]?.portalLayout}</p>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                        <TabPane tabId="1">
                            <Row>
                                <Col sm="12">
                                                    <div className='data_profile'>
                                        <div className='row'>
                                            <div className='col-xl-4 col-md-6 mb-3'>
                                            <h4>Last Update Date</h4>
                                            <p>{moment(userAssociatedRole?.items?.[0]?.updatedAt).format("MMM-DD-YYYY")}</p>
                                            </div>
                                            <div className='col-xl-4 col-md-6 mb-3'>
                                            <h4>Total Users</h4>
                                            <p>{userAssociatedRole?.items?.[0]?.usersWithRole?.length ? userAssociatedRole?.items?.[0]?.usersWithRole?.length : 0}</p>
                                            </div>
                                            <div className='col-xl-4 col-md-6 mb-3'>
                                            <h4>Create Date</h4>
                                            <p>{moment(userAssociatedRole?.items?.[0]?.createdAt).format("MMM-DD-YYYY")}</p>
                                            </div>
                                            <div className='col-xl-4 col-md-6 mb-3'>
                                            <h4>Role Active</h4>
                                                    <p>
                                                        <div className="toggle">
                                                            <input type="checkbox" id="checktoggle"  checked={isActive} onChange={(e)=> handleActiveInActiveToggle(e)} defaultChecked={roleData?.active} />
                                                            <label htmlFor="checktoggle"></label>
                                                        </div>
                                                    </p>
                                            </div>
                                            <div className='col-xl-4 col-md-6 mb-3'>
                                            <h4>Description</h4>
                                            <p>{userAssociatedRole?.items?.[0]?.description}</p>
                                            </div>
                                        </div>
                                    <div className='d-flex justify-content-center gap-3 mt-3' onClick={() => setShowModal(true)}>
                                        <button className="save_btn_blockk" type="submit" onClick={()=> setCurrentTab("rolesListing")}>Back</button>
                                        <button className='acess_btn' >Edit</button>
                                    </div>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="2" className='tab_three'>
                            <div className="table_space data_profile">
                                <div className="table-responsive">
                                    <table>
                                        <thead>
                                            <tr className="header_table">
                                                <th>Full Name</th>
                                                <th>Email</th>
                                                <th>Location</th>
                                                <th>Joined</th>
                                                <th>Active</th>
                                                <th>Employer</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        {userAssociatedRole?.items?.[0]?.usersWithRole?.length > 0 ? userAssociatedRole?.items?.[0]?.usersWithRole.map((user, index) => (
                                            <tbody key={user?._id}>
                                                <tr>
                                                    <td colSpan={9} height={5} className="bg_light"></td>
                                                </tr>
                                                <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                                    <td>{user?.firstName + " " + user?.lastName}</td>
                                                    <td>{user?.email}</td>
                                                    <td>{user?.city + "," + user?.state}</td>
                                                    <td>{moment(user?.createdAt).format("MMM-DD-YYYY")}</td>
                                                    <td><div className={user?.active === true ? "active_block_btn" : "not_active_btn"}>{user?.active == true ? "Active" : "Not Active"}</div></td>
                                                    <td>{user?.employer}</td>
                                                    <td>
                                                        <Dropdown isOpen={dropdownOpen.includes(user?._id)} toggle={() => toggleDropdown(user?._id)} direction={direction}>
                                                            <DropdownToggle caret size="xl" className="drop_blk">
                                                                <div className="for_details">
                                                                    <i className="fa fa-ellipsis-v"></i>
                                                                </div>
                                                            </DropdownToggle>
                                                            <DropdownMenu {...args}>
                                                                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                                                    <div className="add_hosp" onClick={()=> {setCurrentTab("userDetails"); userData(user);}}>View Details</div>
                                                                </DropdownItem>
                                                            </DropdownMenu>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        )) : <tr><td colSpan={10}><p className="text-center">No Data Found</p></td></tr>}
                                    </table>
                                </div>
                            </div>
                            <div className='d-flex justify-content-center mt-3 gap-3'>
                                <button className="save_btn_blockk" type="submit" onClick={()=> setCurrentTab("rolesListing")}>Back</button>
                                <button className='acess_btn d-flex align-items-center gap-2' onClick={() => setShowModalAddRole(true)}><i className="fa fa-plus"></i>Add User Access</button>
                            </div>
                        </TabPane>
                        <TabPane tabId="3" className='tab_three data_profile'>
                            {(!showObjectListing) && (
                                <div className="table-responsive">
                                    <table>
                                        <thead>
                                            <tr className="header_table">
                                                <td>Object Name</td>
                                                <th>Object Permissions</th>
                                                <th>Portal Layout</th>
                                                <th>Hidden</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        {PortalObject?.length > 0 && PortalObject?.map((obj, index) => (
                                            <tbody key={obj?._id}>
                                                <tr>
                                                    <td colSpan={9} height={5} className="bg_light"></td>
                                                </tr>
                                                <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                                    <td>{obj?.objectName}</td>
                                                    <td>{userAssociatedRole?.items?.[0]?.permissions?.find((val) => val?.objectName == obj?.objectName)?.permission?.toString() || '--'}</td>
                                                    <td>{userAssociatedRole?.items?.[0]?.portalLayout}</td>
                                                    <td>
                                                        <div className="toggle">
                                                            <input
                                                                type="checkbox"
                                                                id={`checktoggle-${obj?._id}`}
                                                                onChange={(e) => handleHiddenToggle(e, obj?.objectName)}
                                                                checked={ userAssociatedRole?.items?.[0]?.permissions?.find((val) => val?.objectName === obj?.objectName)?.isHidden}
                                                            />
                                                            <label htmlFor={`checktoggle-${obj?._id}`}></label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <Dropdown isOpen={dropdownOpen.includes(obj?._id)} toggle={() => toggleDropdown(obj._id)} direction={direction}>
                                                            <DropdownToggle caret size="xl" className="drop_blk">
                                                                <div className="for_details">
                                                                    <i className="fa fa-ellipsis-v"></i>
                                                                </div>
                                                            </DropdownToggle>
                                                            <DropdownMenu {...args}>
                                                                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => handleEdit(obj)}>
                                                                    <div className="add_hosp">Edit</div>
                                                                </DropdownItem>
                                                            </DropdownMenu>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ))}
                                    </table>
                                    <button className="save_btn_blockk mt-3" type="submit" onClick={()=> setCurrentTab("rolesListing")}>Back</button>
                                </div>
                            )}
                            {(showObjectListing) && <div className='object_details_edit'>
                                <h2><span>Object Name: </span>{objectDetails?.objectName}</h2>
                                <div className='d-flex justify-content-between gap-4 align-items-start object_table'>
                                    <div className='object_permission table_listing_color'>
                                        <h4 className='field_blk'>Object Permissions</h4>
                                        <div className="table-responsive">
                                            <table>
                                                <thead>
                                                    <tr className="header_table">
                                                        <th>Permission Name</th>
                                                        <th>Enabled</th>
                                                    </tr>
                                                </thead>
                                                {permissionNames.map((obj, index) => (
                                                    <tbody key={index}>
                                                        <tr>
                                                            <td colSpan={9} height={5} className="bg_light"></td>
                                                        </tr>
                                                        <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                                            <td>{obj?.label}</td>
                                                            <td>
                                                                <FormGroup check className="custom-checkbox m-0">
                                                                    <Input
                                                                        type="checkbox"
                                                                        id="customCheckbox"
                                                                        value={obj.value}
                                                                        onChange={(e) => handleCheckBox(e, objectDetails?.objectName)}
                                                                        checked={object?.permission?.includes(obj?.value)}
                                                                    />
                                                                </FormGroup>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                ))}
                                            </table>
                                        </div>
                                    </div>
                                    <div className='field_permission'>
                                        <h4 className='field_blk'>Field Permissions</h4>
                                        <div className="table-responsive">
                                            <table>
                                                <thead>
                                                    <tr className="header_table">
                                                        <th>Field Name</th>
                                                        <th>
                                                            <div className='d-flex align-items-center gap-1'>Read Access<FormGroup check className="custom-checkbox m-0">
                                                                <Input type="checkbox" id="customCheckbox" />
                                                                {' '}
                                                            </FormGroup></div></th>
                                                        <th><div className='d-flex align-items-center gap-1'>Edit Access<FormGroup check className="custom-checkbox m-0">
                                                            <Input type="checkbox" id="customCheckbox" />
                                                            {' '}
                                                        </FormGroup></div></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td colSpan={9} height={5} className="bg_light"></td>
                                                    </tr>
                                                    <tr className="first_block">
                                                        <td>Read</td>
                                                        <td><FormGroup check className="custom-checkbox m-0">
                                                            <Input type="checkbox" id="customCheckbox" />
                                                            {' '}
                                                        </FormGroup></td>
                                                        <td><FormGroup check className="custom-checkbox m-0">
                                                            <Input type="checkbox" id="customCheckbox" />
                                                            {' '}
                                                        </FormGroup></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={9} height={5} className="bg_light"></td>
                                                    </tr>
                                                    <tr className="second_block">
                                                        <td>Create</td>
                                                        <td><FormGroup check className="custom-checkbox m-0">
                                                            <Input type="checkbox" id="customCheckbox" />
                                                            {' '}
                                                        </FormGroup></td>
                                                        <td><FormGroup check className="custom-checkbox m-0">
                                                            <Input type="checkbox" id="customCheckbox" />
                                                            {' '}
                                                        </FormGroup></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={9} height={5} className="bg_light"></td>
                                                    </tr>
                                                    <tr className="first_block">
                                                        <td>Edit</td>
                                                        <td><FormGroup check className="custom-checkbox m-0">
                                                            <Input type="checkbox" id="customCheckbox" />
                                                            {' '}
                                                        </FormGroup></td>
                                                        <td><FormGroup check className="custom-checkbox m-0">
                                                            <Input type="checkbox" id="customCheckbox" />
                                                            {' '}
                                                        </FormGroup></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={9} height={5} className="bg_light"></td>
                                                    </tr>
                                                    <tr className="second_block">
                                                        <td>Delete</td>
                                                        <td><FormGroup check className="custom-checkbox m-0">
                                                            <Input type="checkbox" id="customCheckbox" />
                                                            {' '}
                                                        </FormGroup></td>
                                                        <td><FormGroup check className="custom-checkbox m-0">
                                                            <Input type="checkbox" id="customCheckbox" />
                                                            {' '}
                                                        </FormGroup></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={9} height={5} className="bg_light"></td>
                                                    </tr>
                                                    <tr className="first_block">
                                                        <td>View All</td>
                                                        <td><FormGroup check className="custom-checkbox m-0">
                                                            <Input type="checkbox" id="customCheckbox" />
                                                            {' '}
                                                        </FormGroup></td>
                                                        <td><FormGroup check className="custom-checkbox m-0">
                                                            <Input type="checkbox" id="customCheckbox" />
                                                            {' '}
                                                        </FormGroup></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={9} height={5} className="bg_light"></td>
                                                    </tr>
                                                    <tr className="second_block">
                                                        <td>Modify All</td>
                                                        <td><FormGroup check className="custom-checkbox m-0">
                                                            <Input type="checkbox" id="customCheckbox" />
                                                            {' '}
                                                        </FormGroup></td>
                                                        <td><FormGroup check className="custom-checkbox m-0">
                                                            <Input type="checkbox" id="customCheckbox" />
                                                            {' '}
                                                        </FormGroup></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {isError ? <span style={{ color: "red" }}>{isError}</span> : ""}
                                <div className="d-flex justify-content-between mt-4">
                                    <button className="save_btn" onClick={()=>  setObject(prevState => ({
                                            ...prevState,
                                            permission: []
                                        }))}>Reset</button>
                                    <div className="d-flex gap-3">
                                        <button className="save_btn" onClick={(e) => handleSubmit(e)}>Save</button>
                                    </div>
                                </div>
                            </div>}
                        </TabPane>
                    </TabContent>
                </div>
            </div>
        </Fragment>
    );
}

export default RolesDetails;
